var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isObjective)?_c(_setup.ObjectiveBuilder,{attrs:{"type":_setup.type}}):_c(_setup.FundsBuilder,{attrs:{"ask-for-investor-type":_setup.askForInvestorType,"type":_setup.type}})
}
var staticRenderFns = []

export { render, staticRenderFns }